import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute.js";

//Home
import HomePage from "../Home.js";
import Thecollege from "../Home/Thecollege";
import Principaldesk from "../Home/Principaldesk";
import Vision from "../Home/Vision";
import Mission from "../Home/Mission";

//Department
import DeptCSE from "../Department/Deptcse";
import DeptMOM from "../Department/Deptmom";
import Faculty from "../Department/Faculties";

// Facilities
import LibrarySection from "../Facilities/DigitalLibrary";
import SportsSection from "../Facilities/Sports";
import HostelSection from "../Facilities/Hostel";
import CampusSection from "../Facilities/CollageCampus";

//Activities
import WomenEmpowerment from "../Activities/WomenEmpowerment";
import EventSection from "../Activities/Events";
import NssSection from "../Activities/NSS";
import DCIMClubSection from "../Activities/DCIMClub";

//Training&Placement
import CareerDevCell from "../Training&Placement/CareerDevCell";
import PlacementPoliciesSection from "../Training&Placement/Placement";
import Guidelines from "../Training&Placement/Guidelines";
import RecruitersPage from "../Training&Placement/Recruiters";

// Downloads
import StudentZone from "../Downloads/Studentzone";

// Gallery
import SidebarGalleryPage from "./Sidebargallery";
import Students from "../Feedback/Students";
import Employer from "../Feedback/Employer";
import Parents from "../Feedback/Parents";
import Alumni from "../Feedback/Alumni";

// Grievance Cell components
import About from "../GrivenceCell/About";
import Committee from "../GrivenceCell/Commitee";

// Academics
import AcadCalender from "../Academics/AcadCalender";
import SchemeSyllabus from "../Academics/Scheme&Syllabus";
import Scholarships from "../Academics/Scholarships";
import Specialschemes from "../Academics/Specialschemes";
import RgpvOrdinace from "../Academics/RgpvOrdinace";
import RgpvAct from "../Academics/RgpvAct";
// import TimeTable from '../Academics/TimeTable';
// import Result from '../Academics/Result';
import QuestionPaperManagement from "../Academics/QuestionPaper.js";
import VideoLecture from "../Academics/VideoLec.js";
import NoteSection from "../Academics/Notes.js";

// Admission
import AdmissionProcedure from "../Admission/AdmissionPro";

//Contact Us
import ContactUs from "../ContactUs/ContactUs.jsx";

//Tender
import Tender from "../Tender/Tender";

// Other
import EOAReports from "../other/EOAReport";
import TransferCertificate from "../other/TransferCertificate";
import PaymentPage from "../other/StudentPayment.jsx";

//gallery
import Photo from "../Gallery/Photo";

//admin
import AdminDashboard from "../Admin/Admindashboard/Admindashboard.jsx";
import AdminLoginForm from "../LoginFile/Login.js";

import AddStaffForm from "../Admin/Staff/AddStaff.js";
import StaffList from "../Admin/Staff/ManageStaff.js";

import CommitteeForm from "../Admin/Commitee/AddCommitee.js";
import ManageCommittee from "../Admin/Commitee/ManageCmmitee.js";

import AddEvent from "../Admin/Events/AddEvent.jsx";
import ManageEvents from "../Admin/Events/ManageEvent.jsx";

import AddHostel from "../Admin/Hostel/AddHostel.js";
import ManageHostel from "../Admin/Hostel/ManageHostel.js";

import AddTender from "../Admin/Tender/AddTender.jsx";
import ManageTenders from "../Admin/Tender/ManageTender.jsx";

import SidebarGalleryManagementPage from "../Admin/sidebarGallery/sidebargallery.js";
import AdmissionForm from "../Admission/AdmissionForm.jsx";

import TeacherApplicationForm from "../Recruitment/TeacherApplicationForm.jsx";

import StudentProjectDetails from "../Projects/studentProject.jsx";
import ManageTeacherApplications from "../Admin/recruitment/manageTeacherApplication.jsx";
import HigherEducationList from "../HigherEducation/HigherEducationList.jsx";

import AddStudentForm from "../Admin/Student/AddStudent.jsx";
import ManageStudent from "../Admin/Student/ManageStudent.jsx";

import AddHigherEducation from "../Admin/HigherEducation/AddHigherEducation.js";
import ManageHigherEducation from "../Admin/HigherEducation/ManageHigherEducation.js";

import AddVisionMissionForm from "../Admin/vissionAndMissionMom/AddV&MMom.js";
import ManageVisionMission from "../Admin/vissionAndMissionMom/ManageV&MMom.js";
import MouPdf from "../Academics/MouPdf.js";

const Routess = () => {
  return (
    <Routes>
      {/* normal routes start */}
      <Route path="/" element={<HomePage />} />

      {/* Home route */}
      <Route path="/home/college" element={<Thecollege />} />
      <Route path="/home/principal" element={<Principaldesk />} />
      <Route path="/home/vision" element={<Vision />} />
      <Route path="/home/mission" element={<Mission />} />

      {/* Department route */}
      <Route path="/department/cse" element={<DeptCSE />} />
      <Route path="/department/mom" element={<DeptMOM />} />
      {/* Department syllabus routes - using the same SchemeSyllabus component */}
      <Route path="/department/cse/syllabus" element={<SchemeSyllabus />} />
      <Route path="/department/mom/syllabus" element={<SchemeSyllabus />} />
      <Route path="/department/faculties" element={<Faculty />} />

      {/* Facilities route*/}
      <Route path="/facilities/library" element={<LibrarySection />} />
      <Route path="/facilities/campus" element={<CampusSection />} />
      <Route path="/facilities/hostel" element={<HostelSection />} />
      <Route path="/facilities/sports" element={<SportsSection />} />

      {/* Activities route */}
      <Route path="/activities/events" element={<EventSection />} />
      <Route path="/activities/nss" element={<NssSection />} />
      <Route path="/activities/dcimclub" element={<DCIMClubSection />} />
      <Route
        path="/activities/womenempowerment"
        element={<WomenEmpowerment />}
      />

      {/* Training&Placement route */}
      <Route
        path="/trainingplacement/careerdevelopment"
        element={<CareerDevCell />}
      />
      <Route
        path="/trainingplacement/placementpolicies"
        element={<PlacementPoliciesSection />}
      />
      <Route path="/trainingplacement/guidelines" element={<Guidelines />} />
      <Route path="/trainingplacement/collaborations" element={<MouPdf />} />
      <Route
        path="/trainingplacement/recruiters"
        element={<RecruitersPage />}
      />

      {/* Downloads */}
      <Route path="/downloads/studentzone" element={<StudentZone />} />

      {/* Gallery */}
      <Route path="/sidebargallery" element={<SidebarGalleryPage />} />

      {/* Feedback */}
      <Route path="/feedback/students" element={<Students />} />
      <Route path="/feedback/employer" element={<Employer />} />
      <Route path="/feedback/parents" element={<Parents />} />
      <Route path="/feedback/alumni" element={<Alumni />} />

      {/* Grievance Cell routes */}
      <Route path="/grievancecell/about" element={<About />} />
      <Route path="/grievancecell/committiee" element={<Committee />} />

      {/* Academics */}
      <Route path="/academics/acadcalender" element={<AcadCalender />} />
      <Route path="/academics/scheme-syllabus" element={<SchemeSyllabus />} />
      <Route path="/academics/scholarships" element={<Scholarships />} />
      <Route path="/academics/specialschemes" element={<Specialschemes />} />
      <Route path="/academics/rgpv-ordinace" element={<RgpvOrdinace />} />
      <Route path="/academics/rgpv-act" element={<RgpvAct />} />
      {/* <Route path="/academics/timetable" element={<TimeTable />} /> */}
      {/* <Route path="/academics/result" element={<Result />} /> */}
      <Route
        path="/academics/questionpapermanagement"
        element={<QuestionPaperManagement />}
      />
      <Route path="/academics/videolecture" element={<VideoLecture />} />
      <Route path="/academics/notesection" element={<NoteSection />} />

      {/* Admission */}
      <Route path="/admission/procedure" element={<AdmissionProcedure />} />
      <Route path="/admission/form" element={<AdmissionForm />} />

      {/* Contact Us */}
      <Route path="/contactus" element={<ContactUs />} />

      {/* Tender */}
      <Route path="/tender" element={<Tender />} />

      {/* Gallery */}
      <Route path="/gallery/photos" element={<Photo />} />

      {/* Payment */}
      <Route path="/payment" element={<PaymentPage />} />

      {/* Recruitment */}
      <Route path="/recruitment" element={<TeacherApplicationForm />} />
      <Route
        path="/admin/manage-recruitment"
        element={<ManageTeacherApplications />}
      />

      {/* Projects */}
      <Route path="/projects" element={<StudentProjectDetails />} />

      {/* Higher Studies */}
      <Route path="/higherstudy" element={<HigherEducationList />} />

      {/* Other */}
      <Route path="/other/eoareports" element={<EOAReports />} />
      <Route
        path="/other/transfercertificate"
        element={<TransferCertificate />}
      />

      {/* Admin */}
      <Route path="/admin/addstaffform" element={<AddStaffForm />} />
      <Route path="/admin/managestaff" element={<StaffList />} />

      {/* Vission Mission for MOM Page */}
      <Route path="/admin/addV&Mmom" element={<AddVisionMissionForm />} />
      <Route path="/admin/manageV&Mmom" element={<ManageVisionMission />} />

      <Route path="/admin/addstudentform" element={<AddStudentForm />} />
      <Route path="/admin/managestudent" element={<ManageStudent />} />

      <Route path="/admin/committeeform" element={<CommitteeForm />} />
      <Route path="/admin/managecommittee" element={<ManageCommittee />} />

      <Route path="/admin/addeventform" element={<AddEvent />} />
      <Route path="/admin/manageevents" element={<ManageEvents />} />

      <Route path="/admin/addhostel" element={<AddHostel />} />
      <Route path="/admin/managehostel" element={<ManageHostel />} />

      <Route path="/admin/addtenderform" element={<AddTender />} />
      <Route path="/admin/managetenders" element={<ManageTenders />} />

      <Route
        path='/admin/addHigherEducation"'
        element={<AddHigherEducation />}
      />
      <Route
        path='/admin/addHigherEducation"'
        element={<ManageHigherEducation />}
      />

      <Route
        path="/admin/sidebargallerymanagement"
        element={<SidebarGalleryManagementPage />}
      />

      {/* admin Login */}
      <Route path="/login" element={<AdminLoginForm />} />

      {/* Admin Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* normal routes end */}
    </Routes>
  );
};

export default Routess;
